import PrescriptionButton from 'components/PrescriptionButton';
import PrescriptionModal from 'components/PrescriptionModal';
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { Card, FormControl, Grid, Icon, InputLabel, MenuItem, Modal, Select } from "@mui/material";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getPatientList, sendPaymentLink } from "api/routes";
import { useState } from "react";
import { useEffect } from "react";
import queryString from "components/queryString";
import Loading from "components/Loading";
import { useReactToPrint } from "react-to-print";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { deletePatientInformation } from "api/routes";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "jalali-moment";
import MDInput from "../../components/MDInput";
import { toast } from "react-toastify";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};
export default function ReservedList() {
    const navigate = useNavigate();
    const [prescriptionPatient, setPrescriptionPatient] = useState(null);
    const [page, setPage] = useState(0);
    const [customerPrintInfo, setCustomerPrintInfo] = useState([]);
    const [totalRow, setTotalRow] = useState(25);
    const [moreInfoModal, setMoreInfoModal] = useState({ open: false });

    const resendPaymentLink = (patientId) => {
        const paymentData = {
            patientId,
        };
        sendPaymentLink(paymentData, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            } else {
                setLoading(false);
                toast.success("لینک پرداخت ارسال شد");
            }
        });
    };
    const columns = [
        { field: "patientId", headerName: "کدپیگیری", width: 80 },
        {
            field: "reservationDate",
            headerName: "تاریخ نوبت",
            width: 160,
            valueGetter: (params) => `${params.row.reservationTime} - ${String(params.row.reservationDate).slice(0, 4)}/${String(params.row.reservationDate).slice(4, 6)}/${String(params.row.reservationDate).slice(6)}`,
        },
        {
            field: "groupName",
            headerName: "تخصص نوبت",
            width: 160,
        },
        {
            field: "firstName",
            headerName: "نام",
            width: 120,
        },
        {
            field: "lastName",
            headerName: "نام خانوادگی",
            width: 120,
        },
        {
            field: "mobileNumber",
            headerName: "تلفن همراه",
            width: 120,
        },
        {
            field: "nationalCode",
            headerName: "کدملی",
            width: 120,
        },
        {
            field: "isAdmission",
            headerName: "وضعیت پذیرش",
            width: 100,
            valueGetter: (params) => params.row.isAdmission ? "انجام شده" : "در انتظار",
        },
        {
            field: "admissionDate",
            headerName: "تاریخ پذیرش",
            width: 100,
            render: (params) => <p
                style={{ direction: "ltr !important", wordBreak: "break-all" }}>{params.row.admissionDate}</p>,
        },
        {
            field: "admissionUser",
            headerName: "کاربر پذیرش",
            width: 100,
        },
        {
            field: "insuranceRefCode",
            headerName: "کدپیگیری بیمه",
            width: 100,
        },
        {
            field: "operation",
            headerName: "عملیات",
            width: 150,
            renderCell: (params) =>
                <section style={{ display: "flex", cursor: "pointer", alignItems: "center" }}>
                    <PrescriptionButton key={params.row.patientId} patient={params.row} onOpen={setPrescriptionPatient} />
                    {params.row.reference === "panel" && params.row.success !== 1 &&
                        <Icon title="ارسال مجدد پیامک" style={{ marginLeft: 2 }} onClick={() => {
                            let answer = window.confirm("آیا از ارسال مجدد پیامک اطمینان دارید؟");
                            if (answer) {
                                resendPaymentLink(params.row.patientId);
                            } else {
                            }
                        }}>sms</Icon>}
                    <Icon title="ویرایش" style={{ marginLeft: 2 }}
                        onClick={() => navigate("/update-info", { state: { info: params.row } })}>edit</Icon>
                    <Icon title="چاپ" style={{ marginLeft: 2 }} onClick={() => {
                        setCustomerPrintInfo(params.row);
                        handleOpen();
                    }}>print</Icon>
                    <Icon title="حذف" style={{ color: "red" }} onClick={() => {
                        let answer = window.confirm("آیا از حذف بیمار اطمینان دارید؟");
                        if (answer) {
                            deletePatient(params.row.patientId);
                        } else {
                        }
                    }}>delete</Icon>
                </section>,

        },

    ]
        ;
    const [patientList, setPatientList] = useState([]);
    const [loading, setLoading] = useState(false);
    const componentRef = React.useRef(null);
    const singlePatientRef = React.useRef(null);
    const [successFilter, setSuccessFilter] = useState(1);
    const [searchParam, setSearchParam] = useState(0);
    const [search, setSearch] = useState("");
    const [trigger, setTrigger] = useState(0);
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    useEffect(() => {
        const interval = setInterval(() => {
            window.location.reload();
        }, 300000); // 5 minutes in milliseconds

        return () => clearInterval(interval); // Clear the interval on component unmount
    }, []);
    const m = moment();

    const [selectedDay, setSelectedDay] = useState({
        from: null,
        to: null,
    });

    const renderCustomInput = ({ ref }) => (
        <input
            readOnly
            ref={ref}
            placeholder="بازه زمانی تاریخ"
            value={(selectedDay.from && selectedDay.to) ? `${selectedDay?.from?.year}/${selectedDay?.from?.month}/${selectedDay?.from?.day} - ${selectedDay?.to?.year}/${selectedDay?.to?.month}/${selectedDay?.to?.day}` : ""}
            style={{
                textAlign: "center",
                border: "1px solid #ccc",
                borderRadius: "0.375rem",
                color: "#495057",
                outline: "none",
                height: "44.3px",
                width: "150px",
                fontFamily: "IRANSansX",
            }}
        />
    );

    useEffect(() => {
        setLoading(true);
        let startDate = `${selectedDay?.from?.year}${String(selectedDay?.from?.month).padStart(2, "0")}${String(selectedDay?.from?.day).padStart(2, "0")}`;
        let endDate = `${selectedDay?.to?.year}${String(selectedDay?.to?.month).padStart(2, "0")}${String(selectedDay?.to?.day).padStart(2, "0")}`;

        let query = {
            from: (selectedDay?.to == null || selectedDay?.from == null) ? null : startDate,
            to: (selectedDay?.to == null || selectedDay?.from == null) ? null : endDate,
            page,
            pageSize: 25,
            sort_by_newest: 1,
            success: successFilter === 1 ? 1 : null,
            not_success: successFilter === 0 ? 1 : null,
            is_suspended: successFilter === 2 ? 1 : null,
            last_name: searchParam === 0 ? search : null,
            patient_id: searchParam === 3 ? search : null,
            national_code: searchParam === 1 ? search : null,
            mobile_number: searchParam === 2 ? search : null,
        };

        getPatientList(queryString(query), (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            } else {
                setLoading(false);
                setTotalRow(data?.totalRowCount);
                return setPatientList(data.data);
            }
        });
    }, [selectedDay, page, successFilter, trigger]);

    const patientTablePrintContent = React.useCallback(() => {
        return singlePatientRef.current;
    }, [singlePatientRef.current]);

    const tablePrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const handlePrintSinglePatient = useReactToPrint({
        content: patientTablePrintContent,
        onBeforePrint: () => setLoading(true),
        onAfterPrint: () => setLoading(false),
        removeAfterPrint: true,
    });
    const handlePrint = useReactToPrint({
        content: tablePrintContent,
        onBeforePrint: () => setLoading(true),
        onAfterPrint: () => setLoading(false),
        removeAfterPrint: true,
        pageStyle: "@page {size: A4 landscape;margin: 0;}",
    });
    const deletePatient = (patientId) => {
        setLoading(true);
        deletePatientInformation(patientId, (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message);
            } else {
                setLoading(false);
                toast.success("بیمار حذف شد");
                setPatientList((prev) => prev.filter((p) => p.patientId !== patientId));
            }
        });
    };
    const rows = patientList.map((item, index) => ({ index: index + 1, ...item, operation: "operation" }));
    return (
        <DashboardLayout>
            <PrescriptionModal key={prescriptionPatient?.patientId ?? "closed"} patient={prescriptionPatient} onClose={() => setPrescriptionPatient(null)} />
            <Loading loading={loading} />
            <MDBox pt={2} mb={6}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                            >
                                <MDTypography variant="h6" color="white">
                                    لیست نوبت ها
                                </MDTypography>
                                <DashboardNavbar />
                            </MDBox>
                            <MDBox pt={6} px={2}>
                                <div style={{ marginBottom: 8 }}>
                                    <MDButton onClick={() => navigate("/reservationList/print-preview", { state: { info: patientList } })} variant="gradient" color="info"
                                        sx={{ width: "140px", marginRight: 2 }}>
                                        دریافت گزارش
                                    </MDButton>
                                    <DatePicker
                                        value={selectedDay}
                                        onChange={setSelectedDay}
                                        renderInput={renderCustomInput}
                                        selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                                        selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                                        shouldHighlightWeekends
                                        locale="fa"
                                        colorPrimary="#0fbcf9"
                                        colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                                    />
                                    <FormControl sx={{ width: "150px", marginLeft: 1 }}>
                                        <InputLabel>وضعیت پرداخت</InputLabel>
                                        <Select value={successFilter}
                                            onChange={(event) => setSuccessFilter(event.target.value)}
                                            label="پارامتر جستجو" sx={{ height: "44.3px" }}>
                                            <MenuItem value={1}>پرداخت موفق</MenuItem>
                                            <MenuItem value={0}>پرداخت ناموفق</MenuItem>
                                            <MenuItem value={2}>معلق</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ width: "150px", margin: "0 0.5rem" }}>
                                        <InputLabel>پارامتر جستجو</InputLabel>
                                        <Select value={searchParam}
                                            onChange={(event) => setSearchParam(event.target.value)}
                                            label="پارامتر جستجو" sx={{ height: "44.3px" }}>
                                            <MenuItem value={0}>نام خانوادگی</MenuItem>
                                            <MenuItem value={1}>کد ملی</MenuItem>
                                            <MenuItem value={2}>شماره موبایل</MenuItem>
                                            <MenuItem value={3}>شماره پیگیری</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <MDInput value={search} onChange={(event) => setSearch(event.target.value)}
                                        type="text"
                                        label="جستجو" sx={{ width: "150px" }} />
                                    <MDButton onClick={() => setTrigger(Math.random())} variant="gradient"
                                        color="success"
                                        sx={{ marginLeft: 2 }}>
                                        جستجو
                                    </MDButton>
                                </div>
                                <div id="scrollableDiv">
                                    <DataGrid
                                        rows={rows}
                                        ref={componentRef}
                                        columns={columns}
                                        pageSizeOptions={[25]}
                                        getRowId={(item) => item.patientId}
                                        rowSelection={false}
                                        paginationModel={{ page, pageSize: 25 }}
                                        onPaginationModelChange={(model) => setPage(model.page)}
                                        rowCount={totalRow}
                                        paginationMode="server"

                                    />
                                </div>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <div ref={singlePatientRef} style={{ margin: "1rem", fontSize: 14 }}>
                        <p>نام بیمار: {`${customerPrintInfo?.firstName} ${customerPrintInfo?.lastName}`}</p>
                        <p>کدپیگیری: {customerPrintInfo.patientId}</p>
                        <p>تاریخ
                            نوبت: {`${String(customerPrintInfo.reservationDate).slice(0, 4)}/${String(customerPrintInfo.reservationDate).slice(4, 6)}/${String(customerPrintInfo.reservationDate).slice(6)}`}</p>
                        <p>ساعت نوبت: {customerPrintInfo.reservationTime}</p>
                        <p>تخصص نوبت: {customerPrintInfo.groupName}</p>
                        <p>کدملی: {customerPrintInfo.nationalCode}</p>
                    </div>
                    <MDButton onClick={handlePrintSinglePatient} variant="gradient" color="info"
                        sx={{ width: "140px", marginRight: 4 }}>
                        چاپ
                    </MDButton>

                </MDBox>
            </Modal>
            <Modal open={moreInfoModal.open} onClose={() => setMoreInfoModal({ open: false })}>
                <MDBox sx={style}>
                    <div ref={singlePatientRef} style={{ margin: "1rem", fontSize: 14 }}>
                        <p>سن: {moreInfoModal?.info?.age}</p>
                        <p style={{ margin: "0.5rem 0" }}>وزن: {moreInfoModal?.info?.weight}</p>
                        <p>تلفن ثابت: {moreInfoModal?.info?.tel}</p>
                    </div>
                </MDBox>
            </Modal>
        </DashboardLayout>
    );
}
